import React from 'react';
import { motion } from 'framer-motion';
const cards = [{
  title: 'Ingredientes Básicos',
  desc: 'Solo necesitás maíz, azúcar, aceite y un colorante.',
  image: 'https://images.unsplash.com/photo-1578849278619-e73505e9610f?w=600&q=80',
  color: 'from-palomitas-orange to-amber-400',
  borderColor: 'border-palomitas-orange/40'
}, {
  title: 'En 24 Horas',
  desc: 'Vendé tu primera tanda al día siguiente de empezar.',
  image: 'https://images.unsplash.com/photo-1585647347483-22b66260dfff?w=600&q=80',
  color: 'from-palomitas-coral to-palomitas-pink',
  borderColor: 'border-palomitas-coral/40'
}, {
  title: 'Sistema Completo',
  desc: '📘 Incluye absolutamente TODO para arrancar.',
  image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&q=80',
  color: 'from-palomitas-emerald to-teal-400',
  borderColor: 'border-palomitas-emerald/40'
}];
export function Solution() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-259">
      <div className="absolute top-0 right-0 w-80 h-80 bg-palomitas-emerald/5 rounded-full blur-3xl" data-id="element-260"></div>

      <div className="container px-4 mx-auto max-w-5xl relative z-10" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-262">
          <div className="text-center mb-12" data-id="element-263">
            <span className="inline-block bg-palomitas-emerald/15 text-palomitas-emerald px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-6" data-id="element-264">
              💡 La solución
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-palomitas-brown mb-6" data-id="element-265">
              La solución está en tu cocina
            </h2>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-266">
              Si te gusta lo dulce pero no sabés cómo cobrar sin perder plata,{' '}
              <strong className="text-palomitas-coral" data-id="element-267">
                Palomitas Gourmet
              </strong>{' '}
              te enseña un paso a paso simple para vender tu primera tanda en 24
              horas.
            </p>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 mt-12" data-id="element-268">
            {cards.map((card, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} whileHover={{
            y: -10,
            scale: 1.03
          }} className={`group rounded-2xl overflow-hidden shadow-lg border-2 ${card.borderColor} bg-white cursor-pointer transition-shadow hover:shadow-2xl`} data-id="element-269">
                {/* Card Image */}
                <div className="relative h-48 overflow-hidden" data-id="element-270">
                  <img src={card.image} alt={card.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-271" />
                  <div className={`absolute inset-0 bg-gradient-to-t ${card.color} opacity-40 group-hover:opacity-60 transition-opacity duration-300`} data-id="element-272"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-273">
                    <h3 className="text-xl font-bold text-white drop-shadow-lg" data-id="element-274">
                      {card.title}
                    </h3>
                  </div>
                </div>

                {/* Card Content */}
                <div className="p-5" data-id="element-275">
                  <p className="text-gray-600" data-id="element-276">{card.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}